
import ConfigScene from '../../../helpers/ConfigScene';

class HeavenItem {
  constructor(data) {
    // vars
    this.data = data;
    this.position = {
      z: 1 - (this.data.type.split('_')[1] / 100),
      base: {
        x: this.data.iX,
        y: this.data.iY,
      },
      parallax: {
        x: 0,
        y: 0,
      },
      float: {
        x: 0,
        y: 0,
      },
      item: {
        x: 0,
        y: 0,
      },
    };
  }

  // --------------------------------------------------------------
  // Float
  // --------------------------------------------------------------

  floatStart() {
    this.floatAnimX();
    this.floatAnimY();
  }

  floatStop() {
    TweenMax.killTweensOf(this.position.float);
  }

  floatAnimX() {
    TweenMax.to(this.position.float, 7 + (Math.random() * 7), {
      x: -15 + (Math.random() * 30),
      ease: Sine.easeInOut,
      onComplete: this.floatAnimX,
      onCompleteScope: this,
    });
  }

  floatAnimY() {
    TweenMax.to(this.position.float, 7 + (Math.random() * 7), {
      y: -15 + (Math.random() * 30),
      ease: Sine.easeInOut,
      onComplete: this.floatAnimY,
      onCompleteScope: this,
    });
  }

  // --------------------------------------------------------------
  // Loop
  // --------------------------------------------------------------

  loopUp() {
    // compute parallax position
    this.position.parallax.x = this.position.base.x +
      (aScene.iManager.stageRatio.half.x * (ConfigScene.MOVE_DIFF_SKY.X * this.position.z));
    this.position.parallax.y = this.position.base.y +
      (aScene.iManager.stageRatio.half.y * (ConfigScene.MOVE_DIFF_SKY.Y * this.position.z));

    // combine with float
    this.position.item.x = this.position.parallax.x + this.position.float.x;
    this.position.item.y = this.position.parallax.y + this.position.float.y;
  }
}

export default HeavenItem;



// WEBPACK FOOTER //
// ./src/js/scene/parts/heaven/parts/HeavenItem.js